import BillingNumberCirclesAbstractEditorController from './abstract-editor-controller';

export default class BillingNumberCirclesCreateController extends BillingNumberCirclesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this.loading = false;
    }

    doSave() {
        this.api
            .post(`billing/number-circles`, this.model)
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/number-circles/controllers/create-controller.js